export default {"src":"/login-app/[GIT_HASH]/_next/static/media/sun.f3f6e19e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};